import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4.485a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 1 0 0-16.5m-9.75 8.25c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.365-9.75-9.75m6-2.437c0-.725.588-1.313 1.313-1.313h4.875c.725 0 1.313.588 1.313 1.313v4.875c0 .725-.588 1.312-1.312 1.312H9.563a1.31 1.31 0 0 1-1.312-1.312v-4.875zm1.5.188v4.5h4.5v-4.5z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const StopCircleIcon = ForwardRef;